module.exports = __webpack_public_path__ + "static/media/no-filter.b9729e72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Stores/components/imgs/no-filter.svg
// module id = 822
// module chunks = 0